export const colors = {
  primary: '#1a1a1a',
  gray_background: '#F0F0F0',
  warning: 'rgba(248, 217, 144, 1)',
  critical: 'rgba(245, 107, 82, 1)',
  danger: 'rgba(197, 40, 12, 1)',
  link: 'rgba(69, 143, 255, 1)',
  bgHover: '#f1f1f180',
};
